// extracted by mini-css-extract-plugin
module.exports = {"location":"Location_location___quMS","location-icon":"Location_location-icon__l4TpE","location-name":"Location_location-name__px9FT"};